import { useQuery } from '@hooks/reactQuery';

import { getPortalTasksPriorities } from '@api/portalTasks';

import { optionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { PORTAL_TASKS_PRIORITIES } from '@constants/queryKeys';

interface IUseQueryPortalTasksPrioritiesReturned {
	portalTasksPriorities: Array<TSelectOption>;
	isLoadingPortalTasksPriorities: boolean;
}

export const useQueryPortalTasksPriorities = (): IUseQueryPortalTasksPrioritiesReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [PORTAL_TASKS_PRIORITIES],
		queryFn: getPortalTasksPriorities,
		select: requestTypes => optionsFormatted(requestTypes),
		...refetchOptions,
	});

	return {
		portalTasksPriorities: data || [],
		isLoadingPortalTasksPriorities: isLoading || isFetching,
	};
};
